module.exports = __webpack_public_path__ + "img/new_search.02873781.png";